// extracted by mini-css-extract-plugin
export default {"animation":"animation-mount_animation__81Dri","visible":"animation-mount_visible__VGK5P"};